import { useEffect } from "react";
import Button from "../../../components/atomic/Button";
import Title from "../../LoanTermDeviation/Title";
import { useUtilityStates } from "../useStates";
import LoanTerms from "./LoanTerms";
import OfferBreakdown from "./OfferBreakdown";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";

const OfferCalculator = (props: any) => {

  const { setSidebar, offerCalculation, setOfferCalculation } =
    useUtilityStates((state) => state);

  const handleBackClick = () => {
    setSidebar({ isOpen: true, current: "existing-offers" });
  };

  useEffect(() => {
    let tempOfferCalculation = { ...offerCalculation };
    tempOfferCalculation.loanAmount = 0;
    tempOfferCalculation.rateOfInterset = 0;
    tempOfferCalculation.loanTenure = 0;
    return () => {
      setOfferCalculation(tempOfferCalculation);
    };
  }, []);

  return (
    <div className="p-10">
      <div className="flex gap-4 items-center">
        <Button
          onClick={handleBackClick}
          outline
        >
          <ChevronLeftIcon className="h-4 w-4 text-[#4C4C4D]" />
        </Button>
        <div className="flex text-2xl">Emi Calculator</div>
      </div>
      <div className=" pt-14 ">
        <div className="grid grid-cols-[1fr_auto_1fr] gap-4 items-start">
          <LoanTerms />
          <div className="border-r border-dotted border-gray-400 mx-16 h-full"></div>
          <OfferBreakdown />
        </div>
      </div>
    </div>
  );
};

export default OfferCalculator;
